// src/stone/illustrations/StonjiBarsIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiBarsIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M8.002 8.049v7.946h47.995V8.049h-4v3.946H12V8.05zM8.002 47.92v7.996h47.995V47.92h-4v3.996H12V47.92z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M8.002 27.986v7.992h47.995v-7.992h-4v3.996H12v-3.996z"
        }
      )
    ]
  }
);
var StonjiBarsIllustration_default = StonjiBarsIllustration;

export {
  StonjiBarsIllustration_default
};
